import { render } from "./HorseEditDocumentsView.vue?vue&type=template&id=ce5fb48e&scoped=true"
import script from "./HorseEditDocumentsView.vue?vue&type=script&lang=js"
export * from "./HorseEditDocumentsView.vue?vue&type=script&lang=js"

import "./HorseEditDocumentsView.vue?vue&type=style&index=0&id=ce5fb48e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce5fb48e"]])

export default __exports__